import $api from '@/handler/axios'
import Vue from 'vue'

export const SET_CATEGORIES = 'SET_CATEGORIES'

const state = {
  categories: []
}

const mutations = {
  [SET_CATEGORIES] (state, value) {
    state.categories = value
  }
}

const actions = {
  getCategories (context) {
    return new Promise((resolve, reject) => {
      $api.get('course/category-list/').then(res => {
        context.commit(SET_CATEGORIES, res);
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  categories: state => state.categories
}

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state,
  mutations,
  actions,
  getters
}
